import axios from "axios";
import apis from "../constants/api";

import qs from "querystring";

let _access_token = null;

function _setToken(access_token) {
  _access_token = access_token;
}

const request = async (api, method, params) => {
  return axios({
    method: method,
    url: apis.BASE_URL + api,
    data: qs.stringify(params),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      //'Content-Type': 'application/json',
      Authorization: `Bearer ${_access_token}`,
    },
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      localStorage.setItem("monitoring_system", "");
      window.location.href = "/login";
      return error;
    });
};

export { request, _setToken };
